import Swiper, { Navigation, Pagination, Lazy } from 'swiper';

Swiper.use([Navigation, Pagination, Lazy]);

const cTalentsSliderInit = () => {

    var talentSlider = new Swiper(".js-talents-slider", {
        slidesPerView: 1,
        spaceBetween: 16,
        watchSlidesProgress: true,
        watchSlidesVisibility: true,
        navigation: {
          nextEl: '.c-talents-slider__next',
          prevEl: '.c-talents-slider__prev',
        },
        watchSlidesVisibility : true,
        preloadImages: false,
        lazy: true,
        breakpoints: {
          640: {
            slidesPerView: 2,
          },
          980: {
            slidesPerView: 4,
          },
          1200: {
            slidesPerView: 6,
          }
        },
    })
}

export default cTalentsSliderInit
